import React, { useState } from 'react'
import axios from "@common/axios";
import {Alert} from 'antd'
import { FrownOutlined, SmileOutlined } from '@ant-design/icons'
import CircularLoader from '@common/CircularLoader';

const marks = [1,2,3,4];

const SurveyActivity = ({pathwayUser, step, stepUserResult, setStepUserResult, onContinue}) => {
    const [isUpdating, setUpdating] = useState(false);
    const [error, setError] = useState();

    const handleMarkClick = mark => {
        if (isUpdating) return;

        setUpdating(true);
        axios.post('/web/ui/trail/survey/updateMark', null, {params: {pathwayUserId: pathwayUser.pathwayUserId, stepId: step.stepId,  surveyMark: mark}})
            .then(response => {
                setStepUserResult(response.data);
                setError(undefined);
                if (onContinue) onContinue();
            }).catch(err => {
                setError(err.message);
            }).finally(() => {
                setUpdating(false);
            });
    }

    if (!pathwayUser || !step || !stepUserResult) {
        return <CircularLoader/>;
    }

    return (
        <div className="ch-trail-survey">
            {error && <Alert showIcon type="error" message={error}/>}
            <p>{step.description}</p>
            <div className="flex">
                <FrownOutlined className="emoticon-friends sad-face" />
                {marks.map((mark) => (
                    <div
                        key={mark}
                        className={`ch-self-mark-option ${
                            stepUserResult.mark === mark ? `ch-self-mark-selected-${mark}` : ''
                        }`}
                        onClick={() => handleMarkClick(mark)}
                    />
                ))}
                <SmileOutlined className="emoticon-friends happy-face" />
                <CircularLoader visible={isUpdating} pageCentered={false} displayInElement={true}/>
            </div>
        </div>
    )
}

export default SurveyActivity
